import React from 'react';

import classNames from 'classnames';

import styles from './DropDownWrapper.module.css';

export type Props = {
  children: string | JSX.Element;
  classname?: string;
};

export const DropDownWrapper = React.memo((props: Props) => {
  const {
    children,
    classname,
  } = props;

  return (
    <div className={classNames(styles.dropdown, classname)}>
      {children}
    </div>
  );
});

DropDownWrapper.displayName = 'DropDownWrapper';
